import type { TonyteActivity } from '../types';

/**
 * Who an event's avatar represents in the feed:
 * - 'partner': the partner's own profile picture (venue logo, then their
 *   account photo) — never Tonyte's logo unless they have no picture at all.
 * - 'admin': events uploaded by Tonyte app admins (incl. curated imports)
 *   always show the Tonyte logo, never the admin's personal photo.
 * - 'user': anything else shows the uploader's own photo.
 */
export type EventUploaderKind = 'partner' | 'admin' | 'user';

const ADMIN_ROLES = new Set(['admin', 'co-admin', 'coadmin']);

export function getEventUploaderKind(
  activity: Pick<TonyteActivity, 'createdByRole' | 'partnerId' | 'sourceType'>,
): EventUploaderKind {
  const role = typeof activity.createdByRole === 'string' ? activity.createdByRole.trim().toLowerCase() : '';
  if (role === 'partner' || (!role && activity.partnerId)) return 'partner';
  if (ADMIN_ROLES.has(role) || (!role && activity.sourceType === 'curated_event')) return 'admin';
  return 'user';
}
